import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const supportStatusOptions = [
  { label: 'Resolvido', value: 'closed' },
  { label: 'Não respondido', value: 'not_responded' },
  { label: 'Em andamento', value: 'in_progress' },
]

export const supportStatusStrategy = optionsToStrategy(supportStatusOptions)
